export default __webpack_public_path__ + "static/media/check-mark.5bd550ed.svg";